import { render, staticRenderFns } from "./communication.vue?vue&type=template&id=274e2676&scoped=true&"
import script from "./communication.vue?vue&type=script&lang=js&"
export * from "./communication.vue?vue&type=script&lang=js&"
import style0 from "./communication.vue?vue&type=style&index=0&id=274e2676&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e2676",
  null
  
)

export default component.exports